import { sql } from "drizzle-orm";
import { uuid } from "drizzle-orm/pg-core";
export const uuidv7 = (name) => uuid(name).default(sql `uuidv7()`);
//# sourceMappingURL=uuidv7.js.map